import Reveal from '@/components/base/Reveal';
import { feedItems } from '@/mocks/tracking';

const dotMap = {
  primary: 'border-primary-500',
  accent: 'border-accent-500',
  secondary: 'border-secondary-600',
} as const;

const chipMap = {
  primary: 'bg-primary-100 text-primary-800',
  accent: 'bg-accent-100 text-accent-800',
  secondary: 'bg-secondary-100 text-secondary-800',
} as const;

export default function Feed() {
  return (
    <section id="feed" className="bg-secondary-50/50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <Reveal className="lg:col-span-4">
            <div className="lg:sticky lg:top-24">
              <p className="font-label text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">逐条更新</p>
              <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">最新进展</h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                这里记录每个事件的即时动作：谁回应了、晒了什么证据、放了哪段录音。不做加工，只做时间顺序上的长期跟踪更新。
              </p>
              <div className="mt-6 flex flex-wrap items-center gap-2 text-xs text-foreground-600">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1.5 font-label text-accent-800">
                  <i className="ri-time-line" /> 今日 3 条更新
                </span>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-background-200/70 px-3 py-1.5 font-label text-foreground-700">
                  <i className="ri-archive-line" /> 往期记录已归档
                </span>
              </div>
            </div>
          </Reveal>

          <div className="lg:col-span-8">
            <Reveal>
              <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
                <ul className="relative space-y-0">
                  {feedItems.map((item) => (
                    <li key={item.id} className="relative flex gap-4 pb-7 last:pb-0">
                      <div className="flex flex-col items-center">
                        <span
                          className={`relative z-10 mt-1 h-3.5 w-3.5 shrink-0 rounded-full border-[3px] bg-background-50 ${dotMap[item.tone]}`}
                        />
                        {item !== feedItems[feedItems.length - 1] && (
                          <span className="w-px flex-1 bg-background-200" />
                        )}
                      </div>
                      <div className="min-w-0 flex-1">
                        <div className="flex flex-wrap items-center gap-2">
                          <span className="font-label text-xs font-medium text-foreground-400">{item.time}</span>
                          <span className={`inline-flex rounded-full px-2 py-0.5 font-label text-[11px] font-medium ${chipMap[item.tone]}`}>
                            {item.tag}
                          </span>
                        </div>
                        <p className="mt-1.5 text-sm leading-relaxed text-foreground-800">{item.title}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}